// @ts-nocheck
import { Component } from "react";
import * as ReactDOM from "react-dom";

const modalRoot = document.getElementById("modal-root");

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.container = document.createElement("div");
    this.container.classList.add("modal-wrapper");
    this.renderChildren = this.props.children;
  }

  componentDidMount() {
    modalRoot.appendChild(this.container);
    window.focus();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.className !== this.props.className) {
      const newClassName = this.container.className.replace(new RegExp(prevProps.className, "g"), "").trim();
      this.container.className = newClassName.concat(" ", this.props.className || "");
    }
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.container);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.renderChildren = nextProps.children;
  }

  render() {
    return ReactDOM.createPortal(this.renderChildren, this.container);
  }
}
